<template>
  <div class="p--40px">
    <h1 class="font--32px lh--1 pb--20px">My Compnay Info</h1>
    <form
      @submit.prevent="submit"
      @input="error.errorMessage = ''"
    >
      <text-field-input
        label="회사명"
        name="companyName"
        placeholder="회사명을 입력하세요."
        v-model="row.companyName"
        :error="error"
      ></text-field-input>

      <text-field-input
        label="서브 도메인"
        name="subDomain"
        placeholder="서브 도메인을 입력하세요."
        v-model="row.subDomain"
        :error="error"
      ></text-field-input>

      <text-field-input
        label="E-Mail"
        name="email"
        placeholder="E-Mail을 입력하세요."
        v-model="row.email"
        :error="error"
      ></text-field-input>

      <text-field-input
        label="GA-ID"
        name="gaId"
        placeholder="GA-ID를 입력하세요."
        v-model="row.gaId"
        :error="error"
      ></text-field-input>

      <text-field-textarea
        :required="true"
        :error="error"
        v-model="stringify.theme"
        label="테마"
        name="theme"
      ></text-field-textarea>

      <text-field-textarea
        :required="true"
        :error="error"
        v-model="stringify.mailSetup"
        label="메일 발송 설정"
        name="mailSetup"
      ></text-field-textarea>

      <field-container label="회사 로고">
        <div class="clearfix">
          <named-photo
            name="logo0"
            url="/api/companys/me/images/logo0"
            helpText="일반 로고"
            :extraClass="{width: 'w--280px'}"
            :error="error"
            :accept="['.png', '.jpeg', '.jpg', '.gif', '.svg']"
            @removeFile="row.files.logo0 = ''"
            @error="(err) => error = err"
            @uploaded="(file) => row.files.logo0 = file"
          ></named-photo>
          <named-photo
            name="logo1"
            url="/api/companys/me/images/logo1"
            helpText="반전 로고"
            :extraClass="{width: 'w--280px', bgColor: 'black'}"
            :error="error"
            :accept="['.png', '.jpeg', '.jpg', '.gif', '.svg']"
            @removeFile="row.files.logo1 = ''"
            @error="(err) => error = err"
            @uploaded="(file) => row.files.logo1 = file"
          ></named-photo>
        </div>
      </field-container>

      <field-container label="파비콘">
        <div class="clearfix">
          <named-photo
            name="favicon"
            url="/api/companys/me/images/favicon"
            helpText="일반 이미지 파일도 가능합니다."
            :error="error"
            :accept="['.ico']"
            @removeFile="row.files.favicon = ''"
            @error="(err) => error = err"
            @uploaded="(file) => row.files.favicon = file"
          ></named-photo>
        </div>
      </field-container>

      <!-- <field-container label="파비콘">
        <div class="clearfix">
          <form-thum-files
            :name="'favicon'"
            :error="error"
            :url="`/api/companys/${row.companyId}/favicons`"
            :uuid="''"
            :files="row.favicons"
            :help-text="'일반 로고'"
            :limit="1"
            :uploadStatus="uploadStatus"
            @removeFile="removeFaviconFile"
            @error="onFileError"
            @fileUpload="onFileUpload"
          ></form-thum-files>
        </div>
      </field-container> -->

      <!-- <text-field-thum-files
        :required="true"
        :error="error"
        :url="`/api/companys/${row.companyId}/types/topBanners`"
        :uuid="''"
        :files="row.topBanners"
        :limit="1"
        :accept="['.png', '.jpeg', '.jpg', '.gif', '.svg']"
        label="탑 배너 파일 선택"
        name="topBanners"
        @removeFile="removeFile2"
        @error="onFileError"
        @fileUpload="onFileUpload2"
      ></text-field-thum-files> -->
      <!-- 
      <text-field-thum-files
        :error="error"
        :url="`/api/companys/${row.companyId}/logos`"
        :uuid="''"
        :files="row.logos"
        :limit="1"
        :accept="['.png', '.jpeg', '.jpg', '.gif', '.svg']"
        label="회사 로고 파일 선택"
        name="logos"
        @removeFile="removeFile"
        @error="onFileError"
        @fileUpload="onFileUpload"
      ></text-field-thum-files> -->

      <div class="pt--20px text--center">
        <button
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="$router.push({ name: 'adminMain' })"
        >
          돌아가기
        </button>

        <button
          type="submit"
          class="btn btn--xxxl black text--white ml--4px"
        >저장하기</button>
      </div>
    </form>

  </div>
</template>

<script>
// import Vue from 'vue'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      row: {
        files: {
          logo0: '',
          logo1: ''
        },
        favicons: []
      },
      origin: {},
      error: {},
      uploadStatus: '',
      stringify: {
        theme: '',
        mailSetup: ''
      }
    }
  },
  computed: {
    ...mapState(['company'])
  },
  async created () {
    await this.$load(`/api/companys/${this.company.companyId}`)
    // while (this.row.logos.length < 2) {
    //   this.row.logos.push({})
    // }
    this.stringify.theme = JSON.stringify(this.row.theme, null, 2)
    this.stringify.mailSetup = JSON.stringify(this.row.mailSetup, null, 2)
  },
  methods: {
    async submit () {
      if (this.row.theme && JSON.stringify(this.row.theme) !== this.stringify.theme) {
        this.row.theme = JSON.parse(this.stringify.theme)
      }
      if (this.row.mailSetup && JSON.stringify(this.row.mailSetup) !== this.stringify.mailSetup) {
        this.row.mailSetup = JSON.parse(this.stringify.mailSetup)
      }
      try {
        let ret = await this.$update(`/api/companys/${this.row.companyId}`)
        if (!ret) {
          return
        }
        this.$router.push({ name: 'adminMain' })
      } catch (error) {
        this.error = error
      }
    },
    onRemoveFile (fileName) {
      console.log('------------onRemoveFile-', fileName)
      this.row.logos[fileName] = ''
      // this.row.logos = this.row.logos.filter((file, index) => index !== idx)
    },
    removeFaviconFile (idx) {
      console.log('------------removeFaviconFile-', idx)
      this.row.favicons = this.row.favicons.filter((file, index) => index !== idx)
    }
  },
  components: {
    // // FormThumFile: () => import('@/component/ui2/form/FormThumFile'),
    NamedPhoto: () => import('@/component/common/NamedPhoto'),
    // FormThumbnail: () => import('@/component/ui2/form/FormThumbnail'),
    // FormThumFiles: () => import('@/component/ui2/form/FormThumFiles'),
    TextFieldTextarea: () => import('@/component/ui2/textfield/TextFieldTextarea'),
    TextFieldInput: () => import('@/component/ui2/textfield/TextFieldInput'),
    FieldContainer: () => import('@/component/ui2/uicontainer/FieldContainer')
  }
}
</script>
